import React from "react";
import useAxios from "axios-hooks";
import { API_URL } from "../../../config";
import styled from "styled-components";

const OrderTable = styled.table`
  width: 100%;
  font-family: sans-serif;
  border-collapse: collapse;
  text-align: left;
  tbody,
  th,
  td {
    border: 1px solid black;
  }
  tbody {
  }
  th {
    font-size: 20px;
    height: 50px;
  }
  td {
    padding: 5px;
  }
  tr:hover {
    background-color: #f5f5f5;
    cursor: pointer;
  }
`;

const Orders = () => {
  const [{ data: orders, loading }] = useAxios({
    url: `${API_URL}/getAllOrders`,
    method: "GET",
    withCredentials: true,
  });

  if (loading) return "Loading";

  return (
    <OrderTable>
      <tbody>
        <tr>
          <th>User Email</th>
          <th>Order Id</th>
          <th>Charge Id</th>
          <th>Coupon</th>
          <th>Subtotal</th>
          <th>Total</th>
        </tr>
        {orders.map((order, index) => {
          return (
            <tr key={index}>
              <td>{order.userEmail}</td>
              <td>{order.id}</td>
              <td>{order.charge}</td>
              <td>{order.couponCode}</td>
              <td>
                {order.subtotal &&
                  (order.subtotal / 100).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                  })}
              </td>
              <td>
                {(order.total / 100).toLocaleString("en-US", {
                  style: "currency",
                  currency: "USD",
                })}
              </td>
            </tr>
          );
        })}
      </tbody>
    </OrderTable>
  );
};

export default Orders;
